import React, { useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import { CiSearch } from "react-icons/ci";
import { globalFormManagementServices } from "../../../../../APIServices/globalFormManagementServices";
import { studyOnboardingService } from "../../../../../APIServices/studyOnboarding";
import { studyOtherSettingsServices } from "../../../../../APIServices/studyOtherSettingsServices";
import { NoDataFoundTable, PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
import SplitPane from "react-split-pane";
import UpdateFormFieldGroup from "./UpdateFormFieldGroup";
import Swal from "sweetalert2";
import DeletedFormFieldGroupMetadata from "./DeletedFormFieldGroupMetadata";
import FormFieldGroupProperties from "./FormFieldGroupProperties/FormFieldGroupProperties";
import FormFieldGroupActivities from "./FormFieldGroupProperties/FormFieldGroupActivities";
import FormFieldGroupUpdatedHistory from "./FormFieldGroupProperties/FormFieldGroupUpdatedHistory";
import TableProperties from "./FormFieldGroupProperties/TableProperties";
import UseToggle from "../../../../../Hooks/UseToggle";
import AddFormFieldGroupForm from "./AddFormFieldGroupForm";
import Pagination from "../../../../Pagination";

const FormFieldGroupDataList = ({ onMouseDown, tableRef }) => {
  const [searchData, setSearchData] = useState("");
  const [fieldGroup, setFieldGroup] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [formFieldGroupList, setFormFieldGroupList] = useState([]);
  const [formFieldGroupListCount, setFormFieldGroupListCount] = useState(0);
  const [formDeletedFieldGroup, setFormDeletedFieldGroup] = useState([]);
  const [formDeletedFieldGroupCount, setFormDeletedFieldGroupCount] = useState(null);
  const { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2 } = UseToggle();
  const [loading, setLoading] = useState(false);
  const [fieldGroupLoader, setFieldGroupLoader] = useState(false);
  const [activeTab, setActiveTab] = useState("properties");
  const [categoryId, setCategoryId] = useState("");
  const [activityLoader, setActivityLoader] = useState(false);
  const [formFieldGroupActivity, setFormFieldGroupActivity] = useState([]);
  const [formFieldGroupActivityCount, setFormFieldGroupActivityCount] = useState(0);
  const [historyLoader, setHistoryLoader] = useState(false);
  const [formFieldGroupHistory, setFormFieldGroupHistory] = useState([]);
  const [tableColumns, setTableColumns] = useState({});
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const formColumn = [
    { columnLabel: 'Category Label', columnName: 'CATEGORYLABEL', columnType: 'text' },
    { columnLabel: 'Category Name', columnName: 'CATEGORYNAME', columnType: 'text' },
    { columnLabel: 'Category Code Label', columnName: 'CATEGORYCODELABEL', columnType: 'text' },
    { columnLabel: 'Category Code Name', columnName: 'CATEGORYCODENAME', columnType: 'text' },
    { columnLabel: 'Category Value Label', columnName: 'CATEGORYVALUELABEL', columnType: 'text' },
    { columnLabel: 'Category Value Name', columnName: 'CATEGORYVALUENAME', columnType: 'text' },
    { columnLabel: 'Category Unit Label', columnName: 'CATEGORYUNITLABEL', columnType: 'text' },
    { columnLabel: 'Category Unit Name', columnName: 'CATEGORYUNITNAME', columnType: 'text' },
    { columnLabel: 'Category Remark Label', columnName: 'CATEGORYREMARKLABEL', columnType: 'text' },
    { columnLabel: 'Category Remark Name', columnName: 'CATEGORYREMARKNAME', columnType: 'text' },
  ];

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(formFieldGroupListCount / itemsPerPage);

  const getGlobalFormFieldGroup = async (e) => {
    setLoading(true);
    let data = await globalFormManagementServices.getGlobalFormFieldGroup(
      "active",
      searchData,
      pageNumber,
      itemsPerPage
    );
    setFormFieldGroupList(data?.data || []);
    setFormFieldGroupListCount(data?.count || 0);
    setLoading(false);
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedGlobalFormFieldGroup = async (pageNumberDeleted, itemsPerPageDeleted) => {
    setFieldGroupLoader(true)
    let data = await globalFormManagementServices.getGlobalFormFieldGroup(
      "deleted", "", pageNumberDeleted, itemsPerPageDeleted
    );
    setFormDeletedFieldGroup(data?.data || []);
    setFormDeletedFieldGroupCount(data?.count || null);
    setFieldGroupLoader(false)
  };

  const getGlobalAIAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getGlobalAIAuditTrials(
      "globalFormFieldGroup",
      fieldGroup?.categoryId, pageNumber, itemsPerPage
    );
    setFormFieldGroupActivity(data?.data || []);
    setFormFieldGroupActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  const getTablePropertiesData = async (e) => {
    let data = await studyOtherSettingsServices.getGlobalTablePropertiesData("globalFormFieldGroup");
    setTableColumns(data?.data || {});
  };

  const getGlobalFormFieldGroupAuditTrials = async (e) => {
    setActivityLoader(true);
    let data = await globalFormManagementServices.getGlobalFormFieldGroupAuditTrials(
      fieldGroup?.categoryId,
    );
    setFormFieldGroupHistory(data?.data || []);
    setHistoryLoader(false);
  };

  useEffect(() => {
    getTablePropertiesData()
  }, []);

  useEffect(() => {
    getGlobalFormFieldGroup();
  }, [searchData, pageNumber, itemsPerPage]);

  const softDeleteRestoreGlobalFormFieldGroup = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} form field group!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.id = id;
        userData.type = type;
        let data =
          await globalFormManagementServices.softDeleteRestoreGlobalFormFieldGroup(
            userData
          );
        if (data?.statusCode === 200) {
          getGlobalFormFieldGroup();
          getDeletedGlobalFormFieldGroup();
          setCategoryId("");
          if (type === "restore") {
            getDeletedGlobalFormFieldGroup(pageNumberDeleted, itemsPerPageDeleted);
            setToggle1();
          }
        }
      }
    });
  };

  const updateTableProperties = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Update Table Property!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Update it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.type = "globalFormFieldGroup";
        userData.columns = tableColumns;
        let data = await studyOtherSettingsServices.updateTableProperties(userData);
        if (data?.statusCode === 200) {
          getGlobalFormFieldGroup();
          getTablePropertiesData();
          setToggle2()
        }
      }
      setButtonLoader(false);
    });
  };

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{height: 36}}>
        <div className="hstack gap-1">
          <i
            title={isFormOpen ? "Close Form" : "Add Form Field Group Metadata"}
            onClick={() => {
              setIsFormOpen(!isFormOpen);
              setCategoryId("");
            }}
            className={`fa-solid ${
              isFormOpen ? "fa-table-list" : "fa-plus-square CP"
            }`}
          />
          <div className="vr"></div>
          {formFieldGroupListCount > 0 && (
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 200, padding: "3px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          )}
        </div>
        <div className="hstack gap-2">
          {formFieldGroupListCount > 0 && (
            <button
              onClick={() => { setToggle2(); getTablePropertiesData() }}
              className={`updateProfile`}
            >
              Table Properties
            </button>
          )}
          {formDeletedFieldGroupCount === 0 && (
            <button
              onClick={() => {setToggle1(); getDeletedGlobalFormFieldGroup(pageNumberDeleted, itemsPerPageDeleted)}}
              className={`updateProfile`}
            >
              Deleted History
            </button>
          )}
        </div>
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        minSize={categoryId ? "40%" : "100%"}
      >
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={isFormOpen ? "20%" : "100%"}
        >
          {isFormOpen && <AddFormFieldGroupForm getGlobalFormFieldGroup={getGlobalFormFieldGroup} />}
          {loading ? (
            <PageLoader/>
          ) : formFieldGroupListCount === 0 ? (
            <NoDataFoundTable MSG={"From field group data not found"} />
          ) : formFieldGroupList?.length === 0 ? (
            <NoDataFoundTable MSG={"Search From field group data not found"} />
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                  <thead className="position-sticky top-0 z-1">
                    <tr>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 0)}
                        style={{ width: 45 }}
                        className="text-center"
                      >
                        Sr.
                      </th>
                      {!tableColumns["CATEGORYLABEL"] &&
                        <th onMouseDown={(e) => onMouseDown(e, 1)}>Category Label</th>
                      }
                      {!tableColumns["CATEGORYNAME"] &&
                        <th onMouseDown={(e) => onMouseDown(e, 2)}>Category Name</th>
                      }
                      {!tableColumns["CATEGORYCODELABEL"] &&
                        <th onMouseDown={(e) => onMouseDown(e, 3)}>Category Code Label</th>
                      }
                      {!tableColumns["CATEGORYCODENAME"] &&
                        <th onMouseDown={(e) => onMouseDown(e, 4)}>Category Code Name</th>
                      }
                      {!tableColumns["CATEGORYVALUELABEL"] &&
                        <th onMouseDown={(e) => onMouseDown(e, 5)}>Category Value Label</th>
                      }
                      {!tableColumns["CATEGORYVALUENAME"] &&
                        <th onMouseDown={(e) => onMouseDown(e, 6)}>Category Value Name</th>
                      }
                      {!tableColumns["CATEGORYUNITLABEL"] &&
                        <th onMouseDown={(e) => onMouseDown(e, 7)}>Category Unit Label</th>
                      }
                      {!tableColumns["CATEGORYUNITNAME"] &&
                        <th onMouseDown={(e) => onMouseDown(e, 8)}>Category Unit Name</th>
                      }
                      {!tableColumns["CATEGORYREMARKLABEL"] &&
                        <th onMouseDown={(e) => onMouseDown(e, 9)}>Category Remark Label</th>
                      }
                      {!tableColumns["CATEGORYREMARKNAME"] &&
                        <th onMouseDown={(e) => onMouseDown(e, 10)}>Category Remark Name</th>
                      }
                      <th
                        onMouseDown={(e) => onMouseDown(e, 11)}
                        style={{ width: 45 }}
                        className="text-center"
                      >
                        Edit
                      </th>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 12)}
                        style={{ width: 55 }}
                        className="text-center"
                      >
                        Delete
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {formFieldGroupList?.map((fieldGroup, index) => (
                      <tr
                        key={index}
                        onClick={() => setIsFormOpen(false)}
                        className={`CP ${categoryId === fieldGroup?._id ? "highlighted" : ""
                          }`}
                        title="View Details"
                      >
                        <td
                          onClick={(e) => {
                            {
                              setFieldGroup(fieldGroup);
                              setCategoryId(fieldGroup?._id);
                            }
                          }}
                          className="text-center"
                        >
                          {index + 1 + startIndex}.
                        </td>
                        {!tableColumns["CATEGORYLABEL"] &&
                          <td
                            onClick={(e) => {
                              {
                                setFieldGroup(fieldGroup);
                                setCategoryId(fieldGroup?._id);
                              }
                            }}>
                            {fieldGroup?.categoryLabel}
                          </td>
                        }
                        {!tableColumns["CATEGORYNAME"] &&
                          <td
                            onClick={(e) => {
                              {
                                setFieldGroup(fieldGroup);
                                setCategoryId(fieldGroup?._id);
                              }
                            }}>
                            {fieldGroup?.categoryName}
                          </td>
                        }
                        {!tableColumns["CATEGORYCODELABEL"] &&
                          <td
                            onClick={(e) => {
                              {
                                setFieldGroup(fieldGroup);
                                setCategoryId(fieldGroup?._id);
                              }
                            }}>
                            {fieldGroup?.categoryCodeLabel}
                          </td>
                        }
                        {!tableColumns["CATEGORYCODENAME"] &&
                          <td
                            onClick={(e) => {
                              {
                                setFieldGroup(fieldGroup);
                                setCategoryId(fieldGroup?._id);
                              }
                            }}>
                            {fieldGroup?.categoryCodeName}
                          </td>
                        }
                        {!tableColumns["CATEGORYVALUELABEL"] &&
                          <td
                            onClick={(e) => {
                              {
                                setFieldGroup(fieldGroup);
                                setCategoryId(fieldGroup?._id);
                              }
                            }}>
                            {fieldGroup?.categoryValueLabel}
                          </td>
                        }
                        {!tableColumns["CATEGORYVALUENAME"] &&
                          <td
                            onClick={(e) => {
                              {
                                setFieldGroup(fieldGroup);
                                setCategoryId(fieldGroup?._id);
                              }
                            }}>
                            {fieldGroup?.categoryValueName}
                          </td>
                        }
                        {!tableColumns["CATEGORYUNITLABEL"] &&
                          <td
                            onClick={(e) => {
                              {
                                setFieldGroup(fieldGroup);
                                setCategoryId(fieldGroup?._id);
                              }
                            }}
                            className="text-capitalize"
                          >
                            {fieldGroup?.categoryUnitLabel}
                          </td>
                        }
                        {!tableColumns["CATEGORYUNITNAME"] &&
                          <td
                            onClick={(e) => {
                              {
                                setFieldGroup(fieldGroup);
                                setCategoryId(fieldGroup?._id);
                              }
                            }}
                            className="text-capitalize"
                          >
                            {fieldGroup?.categoryUnitName}
                          </td>
                        }
                        {!tableColumns["CATEGORYREMARKLABEL"] &&
                          <td
                            onClick={(e) => {
                              {
                                setFieldGroup(fieldGroup);
                                setCategoryId(fieldGroup?._id);
                              }
                            }}
                            className="text-capitalize"
                          >
                            {fieldGroup?.categoryRemarkLabel}
                          </td>
                        }
                        {!tableColumns["CATEGORYREMARKNAME"] &&
                          <td
                            onClick={(e) => {
                              {
                                setFieldGroup(fieldGroup);
                                setCategoryId(fieldGroup?._id);
                              }
                            }}
                            className="text-capitalize"
                          >
                            {fieldGroup?.categoryRemarkName}
                          </td>
                        }
                        <td className="text-center" title="Update"
                         onClick={(e) => {
                              setFieldGroup(fieldGroup);
                              setToggle();
                            }}>
                          <FaEdit
                           
                            className="text-muted"
                          />
                        </td>
                        <td className="text-center" title="Delete"
                         onClick={(e) =>
                              softDeleteRestoreGlobalFormFieldGroup(
                                fieldGroup?._id,
                                "delete"
                              )
                            }>
                          <FaTrash
                           
                            className="text-danger"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="position-sticky bottom-0 start-0">
                  <Pagination
                    totalPage={totalPage}
                    pageNumber={pageNumber}
                    itemsPerPage={itemsPerPage}
                    totalItems={formFieldGroupListCount}
                    setPageNumber={setPageNumber}
                    setItemsPerPage={setItemsPerPage}
                  />
                </div>
            </>
          )}
        </SplitPane>
        {categoryId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {["properties", , "history", "activities"].map(
                  (tab) => (
                    <button
                      key={tab}
                      className={`buttonForTabs px-2 ${
                        activeTab === tab ? "activee" : ""
                      }`}
                      onClick={() => setActiveTab(tab)}
                      title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                    >
                      {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  )
                )}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setCategoryId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${
                      !isFullScreen ? "fa-maximize" : "fa-minimize"
                    }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleFullScreen}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "properties" && (
              <FormFieldGroupProperties
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                fieldGroup={fieldGroup}
              />
            )}
            {activeTab === "activities" && (
              <FormFieldGroupActivities
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                formFieldGroupActivity={formFieldGroupActivity}
                activityLoader={activityLoader}
                getGlobalAIAuditTrials={getGlobalAIAuditTrials}
                fieldGroup={fieldGroup}
                formFieldGroupActivityCount={formFieldGroupActivityCount}
              />
            )}
            {activeTab === "history" && (
              <FormFieldGroupUpdatedHistory
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                formFieldGroupHistory={formFieldGroupHistory}
                historyLoader={historyLoader}
                getGlobalFormFieldGroupAuditTrials={getGlobalFormFieldGroupAuditTrials}
                fieldGroup={fieldGroup}
              />
            )}
          </div>
        )}
      </SplitPane>
      <UpdateFormFieldGroup
        Show={!toggle}
        Hide={setToggle}
        fieldGroup={fieldGroup}
        setCategoryId={setCategoryId}
        getGlobalFormFieldGroup={getGlobalFormFieldGroup}
        Title={"Update Form Field Group"}
      />
      <TableProperties
        Show={!toggle2}
        Hide={setToggle2}
        Title={"Table Properties"}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        formColumn={formColumn}
        tableColumns={tableColumns}
        setTableColumns={setTableColumns}
        buttonLoader={buttonLoader}
        updateTableProperties={updateTableProperties}
      />
      <DeletedFormFieldGroupMetadata
        Show={!toggle1}
        Hide={setToggle1}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        setCategoryId={setCategoryId}
        fieldGroupLoader={fieldGroupLoader}
        formDeletedFieldGroup={formDeletedFieldGroup}
        getDeletedGlobalFormFieldGroup={getDeletedGlobalFormFieldGroup}
        formDeletedFieldGroupCount={formDeletedFieldGroupCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreGlobalFormFieldGroup={softDeleteRestoreGlobalFormFieldGroup}
        Title={"Deleted Form Field Group History"}
      />
    </>
  );
};

export default FormFieldGroupDataList;
